<template>
    <div class="modal modal-open" id="modal-add-field">
        <div class="modal-overflow">
            <div class="modal-window">
                <button
                    type="button"
                    class="btn btn-modal-close"
                    @click="handleClose"
                >
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="form-field form-field--text">
                                <label for="name">Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    v-model="field_name"
                                    name="name"
                                />
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.name"
                                >{{ errors.name }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="form-field form-field--tree">
                                <label for="name">Portal field</label>
                                <treeselect
                                    v-model="field_portal_field"
                                    id="portal_field"
                                    name="portal_field"
                                    :multiple="false"
                                    :options="portal_fields_list"
                                />
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.portal_field"
                                >{{ errors.portal_field }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        class="row"
                        style="
                            align-items: center;
                            justify-content: space-between;
                        "
                    >
                        <div
                            class="col-xl-4 col-lg-4 col-md-4"
                            v-if="isMutiselect"
                        >
                            <div
                                class="form-field form-field--text"
                                style="
                                    display: flex;
                                    align-items: center;
                                    padding-right: 12px;
                                "
                            >
                                <label for="limit_field">Limit</label>
                                <input
                                    type="text"
                                    id="limit_field"
                                    v-model="field_limit"
                                    name="limit_field"
                                    ref="limit_field"
                                />
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.limit"
                                >{{ errors.limit }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4">
                            <div class="checkbox">
                                <div class="form-field checkbox-wrap">
                                    <input
                                        type="checkbox"
                                        id="field_mandatory"
                                        :checked="field_mandatory"
                                        @change="
                                            field_mandatory = !field_mandatory
                                        "
                                    />
                                    <label for="field_mandatory">
                                        <i class="icon icon-checkmark"></i>
                                    </label>
                                    Mandatory
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-xl-4 col-lg-4 col-md-4"
                            v-if="isHasOtherValue"
                        >
                            <div class="checkbox">
                                <div class="form-field checkbox-wrap">
                                    <input
                                        type="checkbox"
                                        id="field_other"
                                        :checked="field_other"
                                        @change="field_other = !field_other"
                                    />
                                    <label for="field_other">
                                        <i class="icon icon-checkmark"></i>
                                    </label>
                                    Other value
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <div class="checkbox">
                                <div class="form-field checkbox-wrap">
                                    <input
                                        type="checkbox"
                                        id="field_not_applicable"
                                        :checked="field_not_applicable"
                                        @change="
                                            field_not_applicable =
                                                !field_not_applicable
                                        "
                                    />
                                    <label for="field_not_applicable">
                                        <i class="icon icon-checkmark"></i>
                                    </label>
                                    "Not applicable" option
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row jus-c--center">
                        <div class="btn-wrap jus-c--center">
                            <button
                                @click="handleSubmit"
                                type="button"
                                class="btn"
                            >
                                Save
                            </button>
                        </div>
                        <div class="btn-wrap jus-c--center">
                            <button
                                @click="handleClose"
                                type="button"
                                class="btn"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IMask from "imask";
import Treeselect from "@riophae/vue-treeselect";

export default {
    name: "Modal_Field_Constructor",
    props: [
        "editData",
        "onAdd",
        "onEdit",
        "onClose",
        "portal_fields_list",
        "page",
    ],
    components: {
        Treeselect,
    },
    data() {
        return {
            id: null,
            field_name: "",
            field_portal_field: null,
            field_mandatory: false,
            field_other: false,
            field_limit: 0,
            field_not_applicable: false,
            errors: {
                name: null,
                portal_field: null,
                mandatory: null,
                other: null,
                limit: null,
            },
            limitMask: {
                mask: Number,
                scale: 0,
                radix: null,
                mapToRadix: [],
                signed: false,
                padFractionalZeros: false,
                normalizeZeros: false,
                min: 0,
                max: 100,
            },
        };
    },

    computed: {
        isMutiselect() {
            if (!this.field_portal_field) {
                return false;
            }

            return (
                this.portal_fields_list.find(
                    (p) => p.id === this.field_portal_field
                ).template === "multiselect"
            );
        },
        isHasOtherValue() {
            if (!this.field_portal_field) {
                return false;
            }

            return (
                this.portal_fields_list.find(
                    (p) => p.id === this.field_portal_field
                ).key === "entity_industries" ||
                this.portal_fields_list.find(
                    (p) => p.id === this.field_portal_field
                ).key === "entity_services" ||
                this.portal_fields_list.find(
                    (p) => p.id === this.field_portal_field
                ).key === "entity_niches"
            );
        },
    },

    mounted() {
        if (this.editData) {
            this.id = this.editData.id;
            this.field_name = this.editData.title;
            this.field_portal_field = this.editData.widget.id;
            this.field_mandatory = this.editData.required;
            this.field_other = this.editData.custom;
            this.field_not_applicable = this.editData.not_applicable;

            if ("limit" in this.editData && this.editData.limit) {
                this.field_limit = this.editData.limit;
            }
        }

        this.$forceUpdate();

        if (this.$refs.limit_field) {
            new IMask(this.$refs.limit_field, this.limitMask);
        }
    },

    methods: {
        handleClose() {
            this.onClose();
        },

        validate() {
            this.errors.name = null;
            this.errors.portal_field = null;

            if (!this.field_name) {
                this.errors.name = "Required";
            }

            if (!this.field_portal_field) {
                this.errors.portal_field = "Required";
            }
        },

        handleSubmit() {
            this.validate();

            if (this.errors.name || this.errors.portal_field) {
                return;
            }

            const widget_key = this.portal_fields_list.find(
                (p) => p.id === this.field_portal_field
            ).key;

            const data = {
                title: this.field_name,
                widget: {
                    id: this.field_portal_field,
                    key: widget_key ? widget_key : null,
                },
                required: this.field_mandatory,
                custom: this.field_other,
                not_applicable: this.field_not_applicable,
            };

            if (this.field_limit && this.isMutiselect) {
                data.limit = this.field_limit;
            }

            if (this.editData) {
                data.id = this.editData.id;
                this.onEdit(this.page, data);
                return;
            }

            data.id = Date.now();

            this.onAdd(this.page, data);
        },
    },
};
</script>
